import { Link } from 'react-router-dom';
import { ROUTES } from '@traction/shared';
import { Link2 } from 'lucide-react';

/**
 * Warm intro paths (Person A → B → C): roadmap notes and constraints.
 */
export function WarmIntrosPage() {
  return (
    <div className="mx-auto max-w-3xl space-y-8 p-6">
      <div>
        <h1 className="flex items-center gap-2 text-2xl font-semibold text-white">
          <Link2 className="h-7 w-7 text-amber-400" />
          Warm intros
        </h1>
        <p className="mt-2 text-cacao-muted">
          Plan mutual-connection and intro-chain ideas separately from needs ↔ solutions matching.
        </p>
      </div>

      <section className="space-y-3 rounded-xl border border-cacao-border bg-cacao-surface/40 p-5">
        <h2 className="flex items-center gap-2 text-lg font-medium text-white">
          Person A → B → C
        </h2>
        <p className="text-sm text-cacao-muted">
          True &quot;mutual connection&quot; graphs usually need one of: LinkedIn OAuth with connection
          export (subject to their terms), user-entered &quot;I know X&quot; links, or a data vendor
          that exposes overlap. Apollo enrichment today does not give us a shared Person B between you
          and a lead—so we can&apos;t auto-build daisy chains yet without new data sources or manual
          relationship notes.
        </p>
        <p className="text-sm text-cacao-muted">
          Next steps we can build: tag contacts with &quot;intro path&quot; notes, or import a CSV of
          your network and match names to lead companies.
        </p>
      </section>

      <p className="text-sm">
        <Link to={ROUTES.LEADS} className="text-cacao-accent hover:underline">
          ← Back to Leads
        </Link>
      </p>
    </div>
  );
}
